<div (click)="handleClick()"
    class="relative flex items-end justify-start w-5 h-5 {{bgColorClass()}} rounded-full {{textColorClass()}}">
    <i class="{{ iconClass() }} text-sm translate-x-1.5 translate-y-1"></i>
</div>